import React from 'react';
import { connect } from 'react-redux';
import { getPanels } from '_helpers';
import { PatientCareCenterNoteSpecTestSection } from './Section';
import { renderRLWideHeader } from './Helpers';
import { PatientCareCenterNoteObjectiveSpecTestsPanel } from './SpecTestsPanel';
import styles from './Common.module.css';
import { ObjectiveFlag, DBTextFieldObjective } from '_components';
// SpecTestsPelvicFloorAssessment
class SpecTestsBalanceTesting extends React.Component {

    render() {
        if (this.props.panels.length > 0) {
            return (
                <PatientCareCenterNoteSpecTestSection id='obj_spec_tests_BalanceTesting' name='Balance Testing' visible={false}>
                     <div className={styles.row}>
                            <ObjectiveFlag className={styles.flag} flagged={this.props.nbosFirmSurFlagged} flagText='NBOS Firm Surface' />
                            <label className={styles.lable_space}>NBOS Firm Surface</label>
                            <DBTextFieldObjective
                                    noteId={this.props.noteId}
                                    entity='PTOBJECTIVESPECTESTS'
                                    entityKeyColumn='TSNO'
                                    entityKeyValue={this.props.tsno}
                                    field='TSBALANCENBOSFIRMSURTXT'
                                    className={styles.textArea}
                            /> 
                    </div>

                        <br/>

                        <div className={styles.row}>
                            <ObjectiveFlag className={styles.flag} flagged={this.props.nbosUnsbSurFlagged} flagText='NBOS Unstable Surface' />
                            <label className={styles.lable_space}>NBOS Unstable Surface</label>
                            <DBTextFieldObjective
                                    noteId={this.props.noteId}
                                    entity='PTOBJECTIVESPECTESTS'
                                    entityKeyColumn='TSNO'
                                    entityKeyValue={this.props.tsno}
                                    field='TSBALANCENBOSUNSTBSURTXT'
                                    className={styles.textArea}
                            /> 
                        </div>

                        <br/>

                        <div className={styles.row}>
                            <ObjectiveFlag className={styles.flag} flagged={this.props.nbosFirmSurEyeFlagged} flagText='NBOS Firm Surface Eyes Closed' />
                            <label className={styles.lable_space}>NBOS Firm Surface Eyes Closed</label>
                            <DBTextFieldObjective
                                    noteId={this.props.noteId}
                                    entity='PTOBJECTIVESPECTESTS'
                                    entityKeyColumn='TSNO'
                                    entityKeyValue={this.props.tsno}
                                    field='TSBALANCENBOSFIRMSUREYECLOSEDTXT'
                                    className={styles.textArea}
                            /> 
                        </div>

                        <br/>

                        <div className={styles.row}>
                            <ObjectiveFlag className={styles.flag} flagged={this.props.nbosUnsbSurEyeFlagged} flagText='NBOS Unstable Surface Eyes Closed' />
                            <label className={styles.lable_space}>NBOS Unstable Surface Eyes Closed</label>
                            <DBTextFieldObjective
                                    noteId={this.props.noteId}
                                    entity='PTOBJECTIVESPECTESTS'
                                    entityKeyColumn='TSNO'
                                    entityKeyValue={this.props.tsno}
                                    field='TSBALANCENBOSUNSTBSUREYECLOSEDTXT'
                                    className={styles.textArea}
                            /> 
                        </div>

                        <br/>

                    {renderRLWideHeader()}
                    {
                        Object.keys(this.props.panels)
                            .map(key => {
                                return (<PatientCareCenterNoteObjectiveSpecTestsPanel key={this.props.panels[key].MOPNO} panelId={this.props.panels[key].MOPNO} header='Balance Testing' />);
                            })
                    }
                </PatientCareCenterNoteSpecTestSection>
            );
        } else {
            return (
                <span />
            )
        }
    }
}

function mapStateToProps(state) {
    let noteId = state.ui.patientTabs[state.ui.patientCenter[state.ui.patients.selectedPtno].selectedTab].noteId;
    let noteType = parseInt(noteId.split("_")[0]);
    let pk = parseInt(noteId.split("_")[1]);
    let tsno = parseInt(Object.keys(state.entities.notes.PTOBJECTIVESPECTESTS)
        .find(key => (state.entities.notes.PTOBJECTIVESPECTESTS[key].TSEVNO === pk && noteType === 1)
            || (state.entities.notes.PTOBJECTIVESPECTESTS[key].TSNTNO === pk && noteType !== 1)));

    return {
        noteId: noteId,
        tsno: tsno,
        panels: getPanels(noteId, 'SpecialTest', 'BalanceTesting'),
        nbosFirmSurFlagged: (state.entities.notes.PTOBJECTIVESPECTESTS[tsno].TSBALANCENBOSFIRMSURTXT !== undefined 
            && state.entities.notes.PTOBJECTIVESPECTESTS[tsno].TSBALANCENBOSFIRMSURTXT !== null),
        nbosUnsbSurFlagged: (state.entities.notes.PTOBJECTIVESPECTESTS[tsno].TSBALANCENBOSUNSTBSURTXT !== undefined 
            && state.entities.notes.PTOBJECTIVESPECTESTS[tsno].TSBALANCENBOSUNSTBSURTXT !== null),
        nbosFirmSurEyeFlagged: (state.entities.notes.PTOBJECTIVESPECTESTS[tsno].TSBALANCENBOSFIRMSUREYECLOSEDTXT !== undefined 
            && state.entities.notes.PTOBJECTIVESPECTESTS[tsno].TSBALANCENBOSFIRMSUREYECLOSEDTXT !== null),
        nbosUnsbSurEyeFlagged: (state.entities.notes.PTOBJECTIVESPECTESTS[tsno].TSBALANCENBOSUNSTBSUREYECLOSEDTXT !== undefined 
            && state.entities.notes.PTOBJECTIVESPECTESTS[tsno].TSBALANCENBOSUNSTBSUREYECLOSEDTXT !== null),
    };
}

const connectedSpecTestsBalanceTesting = connect(mapStateToProps)(SpecTestsBalanceTesting);
export { connectedSpecTestsBalanceTesting as SpecTestsBalanceTesting };



